// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader__1ECqi","logo":"logo__1ADoc","message":"message__2FZRC"};